import angular from 'angular'

import {
    printParams
} from 'redevConfig'


const list = (printParams && printParams.list) || ''

const printParamsCtrl = list ? require(`redevelopment/system/printParams/${list.controllerName}`) : require('./printParamsCtrl')

const printParamsTemplate = list ? require(`redevelopment/system/printParams/${list.templateName}`) : require('./view/printParams.html')

export default angular
    .module('system.settingcenter.printParams', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('system.settingcenter.printParams', {
                abstract: true,
                url: '/printParams',
                template: '<div ui-view></div>',
                title: '打印参数',
                default: 'system.settingcenter.printParams.list',
            })
            .state('system.settingcenter.printParams.list', {
                url: '/list',
                template: printParamsTemplate,
                controller: 'printParamsCtrl',
            })
    }])
    .controller('printParamsCtrl', printParamsCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/printParams/index.js